<style type="text/css" media="screen" scoped>
.preview-image{
	width:520px;
	max-height:520px;
}
.close-preview-image{
	vertical-align: top;
}
</style>
<template>
	<div style="width:max-content">
		<v-overlay
		:absolute="absolute"
		:opacity="opacity"
		:value="$store.state.image_viewer"
		:z-index="zIndex"
		>
		<center>
			<div>
				<img :src="image_src" alt="" class="preview-image">
				<v-btn
				fab
				small
				text
				color="#6D7C8E"
				@click="$store.dispatch('setImageViewer',false)"
				class="close-preview-image m-t-negative-10"
				>
				<v-icon color="#ffff" > mdi-window-close</v-icon>
			</v-btn>
		</div>
	</center>
</v-overlay>
</div>
</template>


<script>
export default {
	props:{
		"image_src":{
			default:""
		}
	},
	data: () => ({
		absolute: false,
		opacity: 0.46,
		overlay: true,
		zIndex: 15,

	}),
}
</script>